<template>
  <v-list>
    <v-subheader v-if="!items.length">No assignments available</v-subheader>

    <template v-for="(assignment, index) in items">
      <AssignmentListItem
        :key="assignment._id"
        :assignment="assignment"
      />

      <v-divider
        v-if="index < items.length - 1"
        :key="index"
      />
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'AssignmentsList',
  components: {
    AssignmentListItem: () => import('@/components/assignments/list/AssignmentListItem'),
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
